import { SocialMediaIconsOutline } from "constants/socialMediaIcons";
import React from "react";

import styled from "styled-components";
import { ISocialMediaLinks } from "types/ratedfansData";

const SocialMediaLinks = ({
  facebook,
  instagram,
  tiktok,
  x,
  youtube,
  mail
}: ISocialMediaLinks) => {
  return (
    <Container>
      {instagram && (
        <Icon>
          <a href={instagram} target="_blank" rel="noopener noreferrer">
            {SocialMediaIconsOutline.instagram}
          </a>
        </Icon>
      )}
      {tiktok && (
        <Icon>
          <a href={tiktok} target="_blank" rel="noopener noreferrer">
            {SocialMediaIconsOutline.tiktok}
          </a>
        </Icon>
      )}
      {x && (
        <Icon>
          <a href={x} target="_blank" rel="noopener noreferrer">
            {SocialMediaIconsOutline.x}
          </a>
        </Icon>
      )}
      {facebook && (
        <Icon>
          <a href={facebook} target="_blank" rel="noopener noreferrer">
            {SocialMediaIconsOutline.facebook}
          </a>
        </Icon>
      )}
      {youtube && (
        <Icon>
          <a href={youtube} target="_blank" rel="noopener noreferrer">
            {SocialMediaIconsOutline.youtube}
          </a>
        </Icon>
      )}
      {mail && (
        <Icon>
          <a href={mail} target="_blank" rel="noopener noreferrer">
            {SocialMediaIconsOutline.mail}
          </a>
        </Icon>
      )}
    </Container>
  );
};

export default SocialMediaLinks;

const Container = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  left: 6.4rem;
  bottom: 8.2rem;
  @media only screen and (max-width: 769px) {
    position: relative;
    width: 100%;
    justify-content: center;
    left: 0;
    bottom: 0;
    margin-top: 3.8rem;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 5rem;
  }
`;

const Icon = styled.div`
  width: 3.2rem;
  height: 3.2rem;
  margin-right: 1.2rem;
  cursor: pointer;
  @media only screen and (max-width: 769px) {
    width: 2.4rem;
    height: 2.4rem;
  }
`;
